import styled from 'styled-components';

const StyledImage = styled.img`
	display: block;
	object-fit: contain;
	user-select: none;
	-webkit-user-drag: none;
`;

const StyledSpinnerContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
`;

export { StyledImage, StyledSpinnerContainer };
